"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createQueue = void 0;
const lodash_1 = require("lodash");
function createQueue(maxSize) {
    const queue = [];
    const currentlyProcessing = [];
    function enqueue(action) {
        const id = lodash_1.uniqueId();
        queue.push({ id, start: action });
        update();
    }
    function doneProcessing(id) {
        const index = currentlyProcessing.indexOf(id);
        if (index >= 0) {
            currentlyProcessing.splice(index, 1);
        }
        update();
    }
    function update() {
        if (queue.length <= 0) {
            return;
        }
        if (currentlyProcessing.length < maxSize) {
            const [item] = queue.splice(0, 1);
            currentlyProcessing.push(item.id);
            item.start(item.id);
        }
    }
    return {
        getHandle() {
            return new Promise(resolve => {
                enqueue(handle => {
                    const releaseFunction = () => {
                        setTimeout(() => doneProcessing(handle), 200);
                    };
                    resolve(releaseFunction);
                });
            });
        },
        id: lodash_1.uniqueId(),
    };
}
exports.createQueue = createQueue;
//# sourceMappingURL=createQueue.js.map